import {
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { IMagniteCTVTier } from '~/src/dash/api/demand-settings/magnitectv/magnitectv-tiers_models';
import { IStore } from '~/src/dash/reducers/store';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import {
  errorColor,
  growGrid,
  growGridLeft,
  growGridRight,
} from '~/src/dash/utils/material-dashboard-react';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  firstColumnTitle: string;
  secondColumnTitle: string;

  tiers: IMagniteCTVTier[];
  saveFn: (tiers: IMagniteCTVTier[]) => never;
}

const TIERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16] as number[];

const _ITierTable = (props: IProps) => {
  const [tiers_, setTiers] = useState<IMagniteCTVTier[]>([]);

  useEffect(() => {
    setTiers(props.tiers);
  }, [props.tiers]);

  const updateTier = (tier: IMagniteCTVTier, newValue: number) => {
    const tiers_copy = tiers_.filter((t) => t.MagniteCTVTier !== tier.MagniteCTVTier);
    tier.PublicaTier = newValue;
    tiers_copy.push(tier);
    props.saveFn(tiers_copy);
  };

  const renderMultiSelectForTier = (elem: IMagniteCTVTier) => {
    return (
      <FormControl fullWidth>
        <InputLabel>Tier</InputLabel>
        <Select
          value={elem.PublicaTier}
          label='Tier'
          onChange={(t) => {
            updateTier(elem, t.target.value as number);
          }}
        >
          {TIERS.map((t) => (
            <MenuItem value={t}>{t}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  return (
    <div style={{ width: '500px' }}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{props.firstColumnTitle}</TableCell>
              <TableCell>{props.secondColumnTitle}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(tiers_ || [])
              .sort((a, b) => a.MagniteCTVTier - b.MagniteCTVTier)
              .map((elem) => {
                return (
                  <TableRow>
                    <TableCell>{elem.MagniteCTVTier}</TableCell>
                    <TableCell>{renderMultiSelectForTier(elem)}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export const MagniteCTVTierTable = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
        width: '500px',
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 4,
      },
      button: {
        margin: theme.spacing.unit,
      },
      growGrid,
      growGridLeft,
      growGridRight,
      errorColor: {
        color: errorColor,
      },
      clampTableCell: {
        whiteSpace: 'nowrap',
        width: '1px',
      },
    }),
    router: true,
  },
  _ITierTable,
);
